import React, { useState } from 'react'
import Backdrop from './Backdrop'
import { Box, Heading, Text, Button, SelectMultiple } from 'grommet'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'

import TeamNameInput from '../ReactRTG/teamNameInput'
import { displayPresetGroupModal } from '../../redux/modal/actions'
import InfoButton from '../Button/InfoButton'
import { setPresetGroups as setPresetGroupsRedux } from '../../redux/rtg/actions'

const NamesBox = styled(Box)`
  overflow-x: hidden;
  overflow-y: auto;

  max-height: 45rem;
  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: ${props => props.theme.global.colors.scrollThumb} !important;
  }
`

const PresetGroupModal = () => {
  const groupNum = useSelector(state => state.rtg.numGroups)
  const peoplePersist = useSelector(state => state.rtg.people)
  const people = peoplePersist.filter(person => !person.filtered)
  const presetGroupsRedux = useSelector(state => state.rtg.presetGroups)
  const evenSplit = useSelector(state => state.rtg.evenSplit)
  const [presetGroups, setPresetGroups] = useState(presetGroupsRedux)
  const dispatch = useDispatch()

  return (
    <Backdrop>
      <Box
        round=".5rem"
        width="45rem"
        // height="60rem"
        alignSelf="center"
        align="center"
        justify="center"
        background="baseBackground"
        pad={{ vertical: '2rem', horizontal: '2rem' }}
        gap="1.5rem"
        elevation="small"
      >
        <Box align="center">
          <Box direction="row" align="center">
            <Heading
              level={4}
              size="2rem"
              textAlign="center"
              alignSelf="stretch"
              margin={{ bottom: '0px' }}
            >
              Preset Group Members
            </Heading>
            <InfoButton
              width="38rem"
              position="bottom"
              content={
                <Box gap=".3rem">
                  <Text size="1.5rem">
                    1. Put people in same zone for same group.
                  </Text>
                  <Text size="1.5rem">
                    2. Put people in different zones for different groups.
                  </Text>
                  <Text size="1.5rem">
                    3. Don't set too many members in each zone which has more
                    than the stated max people/group.
                  </Text>
                  <Text size="1.5rem">
                    4. Set this when you really want to preset certain members.
                  </Text>

                  <Text size="1.5rem">
                    5. Will reset every page refresh unless you save to file.
                  </Text>
                </Box>
              }
            />
          </Box>
          <Text textAlign="center" size="1.5rem">
            <b>Only available for Default distribution.</b> Set this after done
            setting the CONTROLLER. Click info above for guide.
          </Text>
        </Box>

        <Button
          primary
          color="primary02"
          label="Add Zone"
          size="xsmall"
          disabled={presetGroups.length >= groupNum}
          onClick={() => {
            const tempPresetGroups = presetGroups.slice(0)
            tempPresetGroups.push([])
            setPresetGroups(tempPresetGroups)
          }}
        />
        <NamesBox gap=".7rem">
          {presetGroups.map((value, index) => {
            let toDisabled = []
            for (let i = 0; i < presetGroups.length; i++) {
              if (i !== index) {
                toDisabled.push(...presetGroups[i])
              }
            }
            return (
              <TeamNameInput
                label={`Zone ${index + 1}`}
                key={`Custom Team Name ${index + 1}`}
              >
                <SelectMultiple
                  value={presetGroups[index]}
                  // showSelectedInline
                  sortSelectedOnClose={false}
                  dropHeight="30rem"
                  placeholder="Select"
                  labelKey="name"
                  valueKey={{ key: 'name' }}
                  // limit={Math.floor(people.length / groupNum)}
                  disabled={toDisabled}
                  options={people}
                  onChange={({ value }) => {
                    const tempPresetGroups = presetGroups.slice(0)
                    tempPresetGroups[index] = value
                    setPresetGroups(tempPresetGroups)
                  }}
                />
              </TeamNameInput>
            )
          })}
        </NamesBox>
        <Box direction="row" gap="small" align="stretch" alignSelf="stretch">
          <Box direction="row" basis="1/2">
            <Button
              primary
              color="reject"
              label="Cancel"
              fill
              onClick={() => {
                dispatch(displayPresetGroupModal(false))
              }}
            />
          </Box>
          <Box direction="row" basis="1/2">
            <Button
              primary
              color="secondary"
              label="Save"
              disabled={evenSplit !== 'Default'}
              fill
              onClick={() => {
                dispatch(setPresetGroupsRedux(presetGroups))
                dispatch(displayPresetGroupModal(false))
              }}
            />
          </Box>
        </Box>
      </Box>
    </Backdrop>
  )
}

export default PresetGroupModal
